import { isEmpty } from 'lodash';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { ExecutiveSummaryEntity } from '@/modules/ta/executivesummaries/models/ExecutiveSummaryEntity';
import { DateUtil } from '@/modules/core/app/utils/DateUtil';
import { getters } from '@/modules/core/app/helpers/store';

export class ExecutiveSummaryItem extends BaseEntityModel {
  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  summary_id;

  /**
   * @var {string}
   */
  page_id;

  /**
   * @var {boolean}
   */
  is_enabled;

  /**
   * @var {string}
   */
  page_title;

  /**
   * @var {string}
   */
  title;

  /**
   * @var {string}
   */
  start_date;

  /**
   * @var {string}
   */
  end_date;

  /**
   * @var {ExecutiveSummaryEntity}
   */
  entity;

  /**
   * @var {string}
   */
  content;

  /**
   * @var {string}
   */
  formatted_start_date;

  /**
   * @var {string}
   */
  formatted_end_date;

  /**
   * @var {boolean}
   */
  is_active;

  /**
   * @var {boolean}
   */
  is_human_verified;

  /**
   * @var {boolean}
   */
  is_new;

  /**
   * @var {string}
   */
  layout_title;

  /**
   * @var {string}
   */
  layout_id;

  /**
   * @var {string}
   */
  report_id;

  /**
   * @var {string}
   */
  report_page_id;

  /**
   * @var {string}
   */
  report_title;

  /**
   * @var {string}
   */
  report_page_title;

  /**
   * @var {string}
   */
  created_at;

  /**
   * @var {string}
   */
  formatted_created_at;

  /**
   * @var {string}
   */
  updated_at;

  /**
   * @var {string}
   */
  formatted_updated_at;

  /**
   * @var {string}
   */
  timegroup;

  /**
   * @var {?number}
   */
  execution_id;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.summary_id = model.summary_id;
    this.page_id = model.page_id;
    this.is_enabled = model.is_enabled;
    this.page_title = model.page_title;
    this.title = model.title;
    this.start_date = model.start_date;
    this.end_date = model.end_date;
    this.entity = !isEmpty(model.entity) ? new ExecutiveSummaryEntity(model.entity) : null;
    this.content = model.content;
    this.formatted_start_date = DateUtil.formatDateFromUnixTimeStamp(model.start_date);
    this.formatted_end_date = DateUtil.formatDateFromUnixTimeStamp(model.end_date);
    this.is_active = model.is_active;
    this.is_human_verified = !!model.is_human_verified;
    this.is_new = model.is_new;
    this.layout_title = model.layout_title;
    this.layout_id = model.layout_id;
    this.report_id = model.report_id;
    this.report_page_id = model.report_page_id;
    this.report_title = model.report_title;
    this.report_page_title = model.report_page_title;
    this.created_at = model.created_at;
    this.formatted_created_at = model.formatted_created_at;
    this.updated_at = model.updated_at;
    this.formatted_updated_at = model.formatted_updated_at;
    this.timegroup = model.timegroup;
    this.execution_id = model.execution_id ?? null;
  }

  createFromDashboardDefaults(summaryId = null) {
    const dashboardDate = getters.daterange.getDateRange();
    this.start_date = dashboardDate.start_date;
    this.end_date = dashboardDate.end_date;

    this.summary_id = summaryId ?? getters.executivesummaries.getSummary().id;
  }
}
